module.exports = __webpack_public_path__ + "img/aquarell_1920_1080_mit_wasserzeichen_22_17.01a3935e.jpg";